import { get, patch, put, del, post, upload } from './client.js';

/* Org branding */
export const getOrgBranding    = (orgId)       => get(`/orgs/${orgId}/branding`);
export const updateOrgBranding = (orgId, body) => patch(`/orgs/${orgId}/branding`, body);
export const resetOrgBranding  = (orgId)       => del(`/orgs/${orgId}/branding`);
export const verifyDomain         = (orgId) => post(`/orgs/${orgId}/branding/verify-domain`, {});
export const testOrgBrandingEmail = (orgId) => post(`/orgs/${orgId}/branding/test-email`, {});
export const getDomainStatus   = (orgId)       => get(`/orgs/${orgId}/branding/domain-status`);

/* Workspace white label */
export const getWhiteLabel    = (wsId)       => get(`/workspaces/${wsId}/whitelabel`);
export const updateWhiteLabel = (wsId, body) => put(`/workspaces/${wsId}/whitelabel`, body);
export const resetWhiteLabel  = (wsId)       => del(`/workspaces/${wsId}/whitelabel`);

/* Resolved branding — computed inheritance chain: workspace → org → platform */
export const getResolvedBranding = (wsId) => get(`/workspaces/${wsId}/resolved-branding`);

/* Public lookup (no auth) */
export const getPublicBranding = (domain) =>
  fetch(`/api/v1/public/branding?domain=${encodeURIComponent(domain)}`).then(r => r.ok ? r.json() : null);

/* Platform-level branding (no auth — used by login page before any session exists) */
export const getPublicPlatformBranding = () =>
  fetch('/api/v1/public/platform').then(r => r.ok ? r.json() : null).catch(() => null);

/* Asset uploads — accepts a File object, returns { url } pointing to /api/v1/public/assets/:key */
const toFormData = (file) => { const fd = new FormData(); fd.append('file', file); return fd; };
export const uploadOrgBrandingAsset    = (orgId, file) => upload(`/orgs/${orgId}/branding/upload`, toFormData(file));
export const uploadWhiteLabelAsset     = (wsId,  file) => upload(`/workspaces/${wsId}/whitelabel/upload`, toFormData(file));
export const uploadPlatformBrandingAsset = (file)      => upload('/platform/settings/branding/upload', toFormData(file));
